var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('ul',{staticClass:"categorias-home"},[_c('li',[_c('img',{attrs:{"src":require("../assets/img/cajas.jpg")}})]),_c('li',[_c('img',{attrs:{"src":require("../assets/img/bolsas.jpg")}})]),_c('li',[_c('img',{attrs:{"src":require("../assets/img/laminas.jpg")}})]),_c('li',[_c('img',{attrs:{"src":require("../assets/img/otros.jpg")}})])])])
}]

export { render, staticRenderFns }